import { _memoize as memoize } from '@deck.gl/core';
export default memoize;
//# sourceMappingURL=memoize.js.map